/** "Lembrar mais tarde" do contrato da plataforma: vale só até o próximo login. */
const SNOOZE_KEY = 'klinvia-platform-contract-snooze';

export function readSnoozedContracts(): string[] {
  try {
    const raw = sessionStorage.getItem(SNOOZE_KEY);
    return raw ? (JSON.parse(raw) as string[]) : [];
  } catch {
    return [];
  }
}

export function snoozeContract(id: string): void {
  try {
    sessionStorage.setItem(SNOOZE_KEY, JSON.stringify(Array.from(new Set([...readSnoozedContracts(), id]))));
  } catch {
    /* noop */
  }
}

export function clearPlatformContractSnooze(): void {
  try {
    sessionStorage.removeItem(SNOOZE_KEY);
  } catch {
    /* noop */
  }
}
